import React, { useState, useEffect } from "react";
import { Navigation } from "../components/navigation";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { SiteData } from "../constants/interfaces";
import { defaultSiteData } from "../constants/globals";
import { applyStyle } from "../style/applyStyle";
import { Button } from "react-bootstrap";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Apply: React.FC = () => {
  const [landingPageData, setLandingPageData] = useState<SiteData>(defaultSiteData);
  const [applicationsOpen] = useState(false);

  useEffect(() => {
    setLandingPageData(JsonData as SiteData);
  }, []);

  return (
    <div>
      <Navigation />

      {/* "Why Join Us?" */}
      <div style={applyStyle.pageContainer}>
        <h1 style={applyStyle.heading}>Why Join Us?</h1>
        <div style={applyStyle.whyUsContainer}>
          <p>
            We would be a great fit for you if you:
          </p>
          <ul style={applyStyle.whyUsList}>
            <li><strong>are a student</strong> passionate about software development and design</li>
            <li>have an interest in <strong>serving your community</strong> while gaining real world experience in <strong>software development</strong></li>
          </ul>
          <p>
            Applications are reviewed on a rolling basis so apply as soon as possible!
          </p>
          <p>
            Applications are open until <strong>October 13, 2025</strong>. Please only complete one application form and indicate which additional roles you'd like to be considered for.
          </p>
        </div>
      </div>

      {/* "Roles"*/}
      <div style={applyStyle.pageContainer2}>
        <h1 style={applyStyle.heading}>Roles</h1>

        <div style={applyStyle.applyContainer}>
          {landingPageData.Apply?.roles && landingPageData.Apply.roles.map((role, index) => (
            <div style={applyStyle.applyCard} key={index}>
              <div className="card" style={applyStyle.card}>
                <div className="card-body d-flex flex-column align-items-center text-center">
                  <h5 style={applyStyle.cardTitle}>{role.title}</h5>
                  <p style={applyStyle.cardText}>{role.description}</p>
                  {(applicationsOpen || role.title === "Software Developer") ? (
                    <Button variant="outline-primary" size="lg"
                      style={{ color: '#ffffff', backgroundColor: '#0573e8', fontWeight: 'bold', marginTop: '20px' }}
                      href={role.link} target="_blank">
                      Apply
                    </Button>
                  ) : (
                    <div style={{ ...applyStyle.cardButton, color: 'gray', fontSize: '18px', fontWeight: 'bold' }}>
                      APPLICATIONS CLOSED
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Apply;
